<template>
  <div>
    <!-- BANNER -->
    <div class="banner">
      <div class="banner-overlay box-overlay brand_accent_bg rounded-top-10">
        <img v-lazy="localImg(banner)" class="img img-luminous" />
      </div>
      <img v-lazy="localImg(display_img)" class="display-img" />
    </div>

    <!-- WELCOME BLOCK -->
    <div
      class="welcome-block w-100 d-flex flex-column justify-content-start align-items-center"
    >
      <div class="welcome-title font-weight-bold brand_navy">
        <template v-if="account_type === 'school' || account_type === 'teacher'"
          >Homework and Assessment</template
        >
        <template v-if="account_type === 'parent'"
          >Personalized Practice</template
        >
      </div>

      <div class="welcome-text color_grey_dark text-center">
        <template v-if="account_type === 'school' || account_type === 'teacher'"
          >Make great learning outcomes happen with tools and analysis for
          formative and summative assessment</template
        >
        <template v-if="account_type === 'parent'"
          >With daily adaptive questions, a practice a day keeps the dull memory
          away</template
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogFour",

  props: ["banner", "display_img"],

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
    };
  },
};
</script>

<style>
</style>
